import { defineMessages, IntlShape } from 'react-intl';

const messages = defineMessages({
  sameEmail: { id: 'app.sml.settings.account.error.sameEmail', defaultMessage: 'That is already your current email.' },
  emailTaken: {
    id: 'app.sml.settings.account.error.emailTaken',
    defaultMessage: 'That email is already in use by another account.',
  },
  codeInvalid: {
    id: 'app.sml.settings.account.error.codeInvalid',
    defaultMessage: 'That verification code is incorrect.',
  },
  codeExpired: {
    id: 'app.sml.settings.account.error.codeExpired',
    defaultMessage: 'That verification code has expired. Please request a new one.',
  },
  generic: { id: 'app.sml.settings.account.error.generic', defaultMessage: 'Something went wrong. Please try again.' },
});

/** The sentence under the email or code field for an error code of users.*EmailChange. */
export function emailChangeErrorMessage(intl: IntlShape, errorCode: string | null): string | null {
  if (errorCode === null) {
    return null;
  }
  switch (errorCode) {
    case 'sameEmail':
      return intl.formatMessage(messages.sameEmail);
    case 'emailTaken':
      return intl.formatMessage(messages.emailTaken);
    case 'codeInvalid':
      return intl.formatMessage(messages.codeInvalid);
    case 'codeExpired':
      return intl.formatMessage(messages.codeExpired);
    default:
      return intl.formatMessage(messages.generic);
  }
}
